<template>
  <el-dialog :title="action=='add'?'添加商机线索':'编辑商机线索'" destroy-on-close append-to-body :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="$emit('input',false)">
    <el-form ref="clueForm" :model="form" :rules="rules" label-width="80px" label-position="top" style="padding: 0 16px;">
      <el-row style="margin-bottom: 10px;" :gutter="20">
        <el-col :span="action=='add'?12:24">
          <el-form-item prop="clue_desc" label="商机描述">
            <el-input v-model.trim="form.clue_desc" type="textarea" placeholder="请输入商机描述，如xx公司需要做一件xx事情..." show-word-limit :autosize="{ minRows: 4, maxRows: 6 }" :maxlength="300"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="action=='add'" prop="progress_plan" label="现阶段进展及规划">
            <el-input v-model.trim="form.progress_plan" type="textarea" placeholder="请输入现阶段进展及规划" show-word-limit :autosize="{ minRows: 4, maxRows: 6 }" :maxlength="300"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 10px;" :gutter="20">
        <el-col :span="8">
          <el-form-item prop="client_name" label="客户名称">
            <el-select ref="clientNameRef" filterable class="form-select" v-model="form.client_name" placeholder="请输入或选择客户名称" @input.native="clientNameInput">
              <template v-slot:empty>
                <div style="padding:6px 20px;font-size:14px;">
                  <!-- <div @click="addClientAction" style="cursor: pointer;color:#409eff;height:34px;line-height:34px;">+ 添加客户</div> -->
                  <div style="color:lightgrey;height:34px;line-height:34px;">暂无结果</div>
                </div>
              </template>
              <el-option v-for="client_name_item in client_name_options" :label="client_name_item" :value="client_name_item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="clue_status" label="商机状态">
            <el-select filterable class="form-select" v-model="form.clue_status" placeholder="请选择商机状态">
              <el-option v-for="item in clue_status_tabs" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="quotation_type" label="计价类型">
<!--            <el-cascader-->
<!--                placeholder="请选择计价类型"-->
<!--                class="form-select"-->
<!--                clearable-->
<!--                :show-all-levels="false"-->
<!--                v-model="quotation_type"-->
<!--                @change="quotationTypeChange"-->
<!--                :options="ClueOption.business_type"-->
<!--                :props="{ multiple: true }"-->
<!--            ></el-cascader>-->
            <el-select filterable class="form-select" v-model="form.quotation_type" placeholder="请选择计价类型" @change="getBusinessTypeByQuoationType">
              <el-option v-for="item in ClueOption.quotation_type_map" :label="item.quotation_type" :value="item.quotation_type"></el-option>
            </el-select>
            <div v-if="form.business_type" style="color: lightgray;font-size: 12px;line-height: 12px;padding-top: 4px;">业务类型：{{form.business_type}}</div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="margin-bottom: 10px;" :gutter="20">
        <el-col :span="8">
          <el-form-item prop="client_manager" label="客户经理">
            <el-select filterable class="form-select" filterable v-model="form.client_manager" placeholder="请选择客户经理" @change="getSecondaryDeptByClientManager()">
              <el-option v-for="item in ClueOption.client_manager" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="primary_dept" label="部门/业务组">
            <el-cascader 
              style="width: 100%;"
              :options="deptOptions" 
              v-model="deptValue"
              @change="changeDept"
              :show-all-levels="false" 
              :props="{value: 'key', label: 'key'}"
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item prop="competitor" label="竞争对手">
              <el-input class="form-select" maxlength="10" show-word-limit v-model.trim="form.competitor"/>
            </el-form-item>
          </el-col>

      </el-row>


      <div v-if="showMore||action!=='add'">
        <el-row style="margin-bottom: 10px;" :gutter="20">
          <el-col :span="8">
            <el-form-item prop="estimate_amount" label="预计金额（万元）">
              <el-input class="form-select" @keyup.native="form.estimate_amount=handleOninput(form.estimate_amount)" v-model.number="form.estimate_amount"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="estimate_start_time" label="预计启动时间">
                <el-date-picker type="date" placeholder="请选择日期" v-model="form.estimate_start_time" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="estimate_close_time" label="预计落地时间">
                <el-date-picker type="month" placeholder="请选择日期" v-model="form.estimate_close_time" format="yyyy-MM" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 10px;" :gutter="20">
          <el-col :span="8">
            <el-form-item prop="contact" label="客户联系人">
              <el-input class="form-select" v-model.trim="form.contact"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="contact_info" label=" 联系方式">
              <el-input class="form-select" v-model.trim="form.contact_info"/>
              <div style="color: lightgray;font-size: 12px;line-height: 12px;padding-top: 4px;">QQ、手机、邮箱</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="success_rate" label="成功率">
              <el-select filterable class="form-select" v-model="form.success_rate">
                <el-option v-for="item in success_rate_tabs" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row style="margin-bottom: 10px;" :gutter="20">
          <el-col :span="8">
            <el-form-item prop="pre_sale">
              <template #label>
                <div>售前是否已介入</div>
              </template>
              <el-radio-group v-model="form.pre_sale" @change="preSaleChange" size="small">
                <el-radio-button label="否">否</el-radio-button>
                <el-radio-button label="是">是</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col v-if="form.pre_sale=='是'" :span="8">
            <el-form-item prop="pre_sale_principal">
              <template #label>
                <div>售前负责人</div>
              </template>
              <el-select filterable class="form-select" filterable v-model="form.pre_sale_principal">
                <el-option v-for="item in ClueOption.pre_sale_principal" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="form.pre_sale=='是'" :span="8">
            <el-form-item prop="pre_sale_time">
              <template #label>
                <div>售前接入时间</div>
              </template>
              <el-date-picker type="date" placeholder="请选择日期" v-model="form.pre_sale_time" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row> -->
      </div>
      <div v-if="!showMore&&action=='add'" @click="showMore=!showMore" style="cursor: pointer;color:#409eff;text-align:center;">展开更多输入项<i class="el-icon-arrow-down"></i></div>
<!--      <div v-if="showMore&&action=='add'" @click="showMore=!showMore" style="cursor: pointer;color:#409eff;text-align:center;">收起<i class="el-icon-arrow-up"></i></div>-->
      <el-form-item style="display: flex;justify-content: end;">
        <el-button :loading="loading" type="primary" @click="onSubmit('clueForm')">确定</el-button>
      </el-form-item>
    </el-form>
    <add-client-dialog v-model="addClientDialogVisble" :client_manager_options="ClueOption.client_manager" :ClueOption="ClueOption" :clueForm="form" :client_name="inputClientName"/>
  </el-dialog>
</template>

<script>
import addClientDialog from "@/component/Business/dialog/addClientDialog";
import {addClue, editClueInfo, exportPerformanceDetail, exportProjectDetail, getClueOption} from "@/api/api";
import {clue_status_tabs, quotation_type} from "@/config";
export default {
  name: "addBusinessDialog",
  components:{
    addClientDialog
  },
  props:{
    action:{
      type: String,
      default:"add"
    },
    value:{
      type: Boolean,
      default:false,
      required: true
    },
    editForm:{
      type:Object
    }
  },
  data() {
    return {
      dialogFormVisible: false,
      addClientDialogVisble: false,
      inputClientName:"",
      refreshId:0,
      quotation_type:[],
      showMore:true,
      client_name_options:[],
      ClueOption:{
        "client_manager": [],
        "client_name": [],
        "pre_sale_principal":[],
        quotation_type_map:[]
      },
      success_rate_tabs:[
        {
          label:"高"
        },
        {
          label:"中"
        },
        {
          label:"低"
        }
      ],
      clue_status_tabs:clue_status_tabs,
      initForm:{
        "clue_status": "",
        "client_name": "",
        "quotation_type": "",
        "business_type": "",
        "clue_desc": "",
        "progress_plan": "",
        "client_manager": this.$cookies.get("username"),
        "primary_dept": "",
        "secondary_dept": "",
        "estimate_start_time": "",
        "estimate_close_time": "",
        "estimate_amount": "",
        "contact":"",
        "contact_info": "",
        "competitor": "",
        "success_rate": "",
        "pre_sale": "否",
        "pre_sale_principal": "",
        "pre_sale_time": "",
      },
      form: {
        "clue_status": "",
        "client_name": "",
        "quotation_type": "",
        "business_type": "",
        "clue_desc": "",
        "progress_plan": "",
        "client_manager": this.$cookies.get("username"),
        "primary_dept": "",
        "secondary_dept": "",
        "estimate_start_time": "",
        "estimate_close_time": "",
        "estimate_amount": "",
        "contact":"",
        "contact_info": "",
        "competitor": "",
        "success_rate": "",
        "pre_sale": "否",
        "pre_sale_principal": "",
        "pre_sale_time": "",
      },

      hiddenQuotationTypeTips:false,
      rules: {
        clue_desc: [
          { required: true, message: '请输入商机描述', trigger: 'blur' }
        ],
        progress_plan: [
          { required: true, message: '请输入现阶段进展及规划', trigger: 'blur' }
        ],
        client_name: [
          { required: true, message: '请输入或选择客户名称', trigger: 'change' }
        ],
        clue_status: [
          { required: true, message: '请选择商机状态', trigger: 'change' }
        ],
        estimate_amount: [
          { required: true, message: '请输入预计金额（万元）', trigger: 'blur' },
          { type: 'number', message: '请输入数字', trigger: 'blur'}
        ],
        contact: [
          { required: true, message: '请输入客户联系人', trigger: 'blur' }
        ],
        contact_info: [
          { required: true, message: '请输入客户联系方式', trigger: 'blur' }
        ],
        success_rate: [
          { required: true, message: '请选择成功率', trigger: 'change' }
        ],
        quotation_type: [
          {
            required:true,
            validator: (rule, value, callback) => {
              // console.log('rule',rule)
              if (value === '') {
                this.hiddenQuotationTypeTips = true
                callback(new Error('请选择计价类型'));
              } else {
                this.hiddenQuotationTypeTips = false
                callback();
              }
            }, trigger: ['change']
          }
          // { required: true, message: '请选择计价类型', trigger: 'change' }
        ],
        client_manager:[
          { required: true, message: '请输入客户经理名称', trigger: 'blur' }
        ],
        primary_dept:[
          { required: true, message: '请选择部门', trigger: 'change' }
        ],
        estimate_start_time:[
          { required: true, message: '请选择预计启动时间', trigger: 'change' }
        ],
        estimate_close_time: [
          { required: true, message: '请选择预计落地时间', trigger: 'change' }
        ]
      },

      loading:false,
      deptOptions: [],
      deptValue: []
    }
  },

  watch:{
    '$store.state.updateClientList'(newVal){
      // console.log('updateClientList变化')
      this.getClientNameList()
    },
    editForm(newVal){
      // console.log('editForm',newVal)
      this.form = JSON.parse(JSON.stringify(newVal))

      this.deptValue = this.action === 'edit' ? [this.form.primary_dept,this.form.secondary_dept] : []
      console.log('watch更新', this.deptValue);
    },
    value(newVal){
      this.dialogFormVisible = newVal
      if(this.dialogFormVisible){
        this.refresh()
      }
    }
  },
  created () {
    getClueOption({}).then(res=>{
      this.deptOptions = res.respData.dept_list
    });
  },
  mounted() {
    this.getClientNameList()

    this.getSecondaryDeptByClientManager()
  },
  methods:{
    quotationTypeChange(e){
      this.form.quotation_type = e.map(arr=>arr[1]).join()
      this.form.business_type = e.map(arr=>arr[0]).join()
      // console.log('quotationTypeChange',e,this.form.quotation_type,this.form.business_type)

    },
    handleOninput(value){
      let str = value;
      let len1 = str.substr(0, 1);
      let len2 = str.substr(1, 1);
      //如果第⼀位是0，第⼆位不是点，就⽤数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1);
      }
      //第⼀位不能是.
      if (len1 == ".") {
        str = "";
      }
      if (len1 == "+") {
        str = "";
      }
      if (len1 == "-") {
        str = "";
      }
      //限制只能输⼊⼀个⼩数点
      if (str.indexOf(".") != -1) {
        let str_ = str.substr(str.indexOf(".") + 1);
        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
        }
      }
      //正则替换
      str = str.replace(/[^\d^\.]+/g, ""); // 保留数字和⼩数点

        str = str.replace(/^\D*([0-9]\d*\.?\d{0,10})?.*$/, "$1"); // ⼩数点后只能输 10 位

      return str;
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log('submit!',this.form);
          this.addClueAction()
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },

    async addClientAction(){
      this.$refs.clientNameRef.blur()
      this.addClientDialogVisble = true
    },

    async addClueAction(){
      this.loading = true
      if(this.action=='add'){
        let res = await addClue(this.form)
        if(res.respCode&&res.respCode=='000000'){
          // console.log('addClueAction',res)
          this.$message.success(res.respMsg)
          this.$emit('refresh')
          this.$nextTick(()=>{
            this.loading = false
            this.form = JSON.parse(JSON.stringify(this.initForm))
            this.$emit('input',false)
          })
        }else{
          this.$message.error(res.respMsg)
        }
      }else{
        let editList = []
        for (let formKey in this.form) {
         if(this.form[formKey]!==this.editForm[formKey]){
           editList.push({
             key:formKey,
             old_value:this.editForm[formKey],
             new_value:this.form[formKey]
           })
         }
        }
        let postData = {
          clue_id:this.form.clue_id,
          edit_info:editList
        }
        // console.log('editClueInfo',postData)
        let res = await editClueInfo(postData)
        if(res.respCode&&res.respCode=='000000'){
          // console.log('editClueInfo',res)
          this.$message.success(res.respMsg)
          this.$emit('refresh')
          this.$nextTick(()=>{
            this.loading = false
            this.$emit('input',false)
          })
        }else{
          this.$message.error(res.respMsg)
        }
      //  editClueInfo
      }

    },

    /**
     * 获取客户列表
     * @param content
     */
    async getClientNameList(){
      let pData = {
      }
      let res = await getClueOption(pData)
      // console.log('getClientNameList',res)
      if(res.respCode&&res.respCode=='000000'){
        let ClueOption = res.respData
        let business_type = ClueOption.business_type
            let quotation_type_map = business_type.reduce((a,b)=>{
              let quotation_type_right = b.children ? b.children.map(quo=>{return{quotation_type:quo.value,business_type:b.value}}) : []
              return [...a,...quotation_type_right]
            },[])
        // console.log('quotation_type_map',quotation_type_map)
        ClueOption.quotation_type_map = quotation_type_map
        this.ClueOption = ClueOption
        this.client_name_options = this.ClueOption.client_name
      }else{
        this.$message.error(res.respMsg)
      }
    },

    clientNameInput(e){
      // console.log('clientNameInput',e.target.value)
      this.inputClientName = e.target.value
      // // this.form.client_name = val
      // if (val) {
      //     let client_name_options = this.ClueOption.client_name.filter((item) => {
      //     if (item.includes(val) || item.toUpperCase().includes(val.toUpperCase())) {
      //       return true
      //     }
      //
      //     if(client_name_options){
      //       this.client_name_options = JSON.parse(JSON.stringify(client_name_options))
      //     }else{
      //       if(this.client_name_options.length){
      //         this.client_name_options = []
      //       }
      //     }
      //     console.log('this.client_name_options',this.client_name_options)
      // })
      // } else {
      //   this.client_name_options = this.ClueOption.client_name;
      // }
    },

    /**
     * 根据客户经理获取组别
     * @param client_manager
     * @returns {Promise<void>}
     */
    async getSecondaryDeptByClientManager(){
      let pData = {
        index: "client_manager",
        client_manager: this.form.client_manager
      }
      let res = await getClueOption(pData)
      // console.log('getSecondaryDeptByClientName',res,pData)
      if(res.respCode&&res.respCode=='000000'){
        let getPDept = res.respData[0]?.primary_dept
        let getSDept = res.respData[0]?.secondary_dept
        if(getSDept){
          const values = [getPDept,getSDept]
          this.changeDept(values)
          this.deptValue = values
        }else{
          this.form.primary_dept = ""
          this.form.secondary_dept = ""
        }
      }else{
        this.$message.error(res.respMsg)
      }
    },

    /**
     * 根据计价类型获取业务类型
     * @param client_name
     * @returns {Promise<void>}
     */
    getBusinessTypeByQuoationType(quotation_type) {
      let quotation_type_map_item = this.ClueOption.quotation_type_map.find(function (item) {
        return item.quotation_type === quotation_type;
      })
      if (quotation_type_map_item) {
        this.form.business_type = quotation_type_map_item.business_type
        // console.log('getBusinessTypeByQuoationType', this.form.business_type, quotation_type_map_item)
      }
    },

    preSaleChange(){
      if(this.form.pre_sale=='否'){
        this.form.pre_sale_time = ""
        this.form.pre_sale_principal = ""
      }
    },

    refresh(content){
      this.refreshId +=1
    },

    changeDept(values) {
      const [ primary_dept, secondary_dept ] = values;
      this.form.primary_dept = primary_dept
      this.form.secondary_dept = secondary_dept
    }
  }
}
</script>

<style scoped>
/deep/ .form-select.el-select{
  width: 100%;
}
</style>
